/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { CreateContactsBatchMutationRequest, CreateContactsBatchMutationResponse, CreateContactsBatchHeaderParams, CreateContactsBatch401 } from "../../models/contactsController/CreateContactsBatch";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createContactsBatchMutationKey = () => [{ url: '/contacts/batch' }] as const

export type CreateContactsBatchMutationKey = ReturnType<typeof createContactsBatchMutationKey>

/**
 * {@link /contacts/batch}
 */
export async function createContactsBatch(data: CreateContactsBatchMutationRequest, headers?: CreateContactsBatchHeaderParams, config: Partial<RequestConfig<CreateContactsBatchMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateContactsBatchMutationResponse, ResponseErrorConfig<CreateContactsBatch401>, CreateContactsBatchMutationRequest>({ method : "POST", url : `/contacts/batch`, data : requestData, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function createContactsBatchMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateContactsBatchMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createContactsBatchMutationKey()
        return mutationOptions<CreateContactsBatchMutationResponse, ResponseErrorConfig<CreateContactsBatch401>, {data: CreateContactsBatchMutationRequest, headers?: CreateContactsBatchHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, headers }) => {
            return createContactsBatch(data, headers, config)
          },
        })

}

/**
 * {@link /contacts/batch}
 */
export function useCreateContactsBatch<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateContactsBatchMutationResponse, ResponseErrorConfig<CreateContactsBatch401>, {data: CreateContactsBatchMutationRequest, headers?: CreateContactsBatchHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateContactsBatchMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createContactsBatchMutationKey()

          const baseOptions = createContactsBatchMutationOptions(config) as UseMutationOptions<CreateContactsBatchMutationResponse, ResponseErrorConfig<CreateContactsBatch401>, {data: CreateContactsBatchMutationRequest, headers?: CreateContactsBatchHeaderParams}, TContext>
          

          return useMutation<CreateContactsBatchMutationResponse, ResponseErrorConfig<CreateContactsBatch401>, {data: CreateContactsBatchMutationRequest, headers?: CreateContactsBatchHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateContactsBatchMutationResponse, ResponseErrorConfig<CreateContactsBatch401>, {data: CreateContactsBatchMutationRequest, headers?: CreateContactsBatchHeaderParams}, TContext>
      
}